import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './App.css';

function App() {
  const [tabId, setTabId] = useState(0);
  const [text, setText] = useState("");
  const [format, setFormat] = useState("audio");

  // Request flow
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [response, setResponse] = useState("");

  const handleType = (event) => {
    setText(event.target.value);
  };

  const handleFormatChange = (event) => {
    setFormat(event.target.value);
  };

  const getIdFromUrl = (url) => {
    if (url.includes("youtu.be") || url.includes("shorts")) {
      return url.split('/').slice(-1)[0].split('?')[0];
    } else if (url.includes("v=")) {
      return url.split("v=")[1].split('&')[0];
    }
    return "";
  }

  const fetchData = async () => {
    if (text.length == 0) return;
    setLoading(true);
    setError("");
    setResponse("");
    try {
      let id = getIdFromUrl(text);
      console.log(id);
      if (!id) {
        console.log("in error");
        setError("Couldn't recognize the URL format");
        return;
      }
      const response = await axios.get(
        `https://j5vg0xib5f.execute-api.us-west-2.amazonaws.com/find?mode=${format}&id=${id}`
      );
      console.log(response);
      setResponse(response.data);
      window.open(response.data, "_blank", "noopener,noreferrer");
    } catch (err) {
      setError(err.toString());
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <div className="tab-link" onClick={() => {setTabId(1)}}>About</div>
      <div className="tab-link" onClick={() => {setTabId(0)}}>Find Files</div>
      <div id="center">
        <div className="content">
          { tabId == 0 ?
            <div className="container find">
              <div>
                <div className="text stack">I want to download </div>
                <select id="dropdown" className="stack" value={format} onChange={handleFormatChange}>
                  <option value="audio">audio</option>
                  <option value="video">video</option>
                  <option value="video only">video only</option>
                </select>
                <div className="text stack">for the video at</div>
                <input id="textbox" className="stack" type="text" value={text} onChange={handleType} placeholder="video url"/>
                <div>
                  <div id={`go${text.length == 0 ? '-disabled' : ''}`} onClick={() => {fetchData()}}>Take me there</div>
                </div>
                {response ? <div className="response text stack">Found video at <a href={response}>{response}</a></div> : <div></div>}
                {loading ? <div className="loading text stack">loading...</div> : <div></div>}
                {error ? <div className="error text stack">{error}</div> : <div></div>}
              </div>
            </div> :
            <div className="container faq">
              <div className="faq question">How does this work?</div>
              <div className="faq answer">
                Many YouTube downloaders work by downloading video and audio from YouTube to their own servers,
                then redistributing it to end users. <b>This website does not do this.</b> In fact, at no point
                do any files from YouTube touch this website's servers.
              </div>
              <div className="faq answer">
                Instead, what this website does is even more simple: it just shows you the location of the video file
                you want on YouTube's own servers. Specifically, given the URL for a video, it calls public YouTube APIs
                to determine where your browser would stream the video from, then directs you to that location.
                This process doesn't use any API keys, paid access, or other hacky shenanigans-- you could do the same
                process anywhere, on any device, for free, using any request generation tool (like Postman or cURL).
                Many libraries already exist in various programming languages which can do this process for you.
              </div>
              <div className="faq answer">
                There's a presumption that, if YouTube didn't want you to access these files, they wouldn't make them
                so publicly available, nor so easy to find.
              </div>
              <div className="faq question">Why is there a video only option?</div>
              <div className="faq answer">Files containing both video and audio (also called "integrated" streams) tend to be lower-resolution than streams with only video. If you want 1080p video, try using video only.</div>
              <div className="faq question">Why doesn't (insert video) work?</div>
              <div className="faq answer">
                Since no paid access (or in fact, any authentication at all) is used to fetch these file locations,
                if any kind of special access is needed to view your video, <b>this tool will not be able to find it. </b> 
                Likewise, certain videos deemed especially vulnerable by YouTube may not be retrievable with the methods
                used by this website.
              </div>
              <div className="faq question">I can't download the video/audio at the link!</div>
              <div className="faq answer">
                Some browsers may not let you download these files directly. Try using Chrome or Edge.
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  );
}

export default App;
